'use strict';

const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');

module.exports=AngularHelpers.registerModule({
name:'fdc.features.profile',
dependencies:['ui.router'],
configs:[
require('./profileConfig')],

components:[
require('./profileController'),
require('./components/userProfile/userProfileDirective'),
require('./components/userProfile/editUserModalController'),
require('./components/userProfile/changeUserPasswordModalController')]});
//# sourceMappingURL=index.js.map
